import { ForgotPasswordStep } from "@/components/auth/forgot-password-step"
import { LoginForm } from "@/components/auth/login-form"
import { useLoginFlow } from "@/hooks/auth/useLoginFlow"

export function LoginPage() {
  const login = useLoginFlow()

  if (login.mode === "forgot") {
    return (
      <ForgotPasswordStep
        email={login.forgotEmail}
        emailError={login.forgotEmailError}
        submitError={login.forgotError}
        successMessage={login.forgotSuccess}
        isLoading={login.isForgotLoading}
        onEmailChange={login.updateForgotEmail}
        onSubmit={login.handleForgotSubmit}
        onBack={login.closeForgotMode}
        onGoHome={login.goToHome}
      />
    )
  }

  return (
    <LoginForm
      form={login.form}
      fieldErrors={login.fieldErrors}
      submitError={login.submitError}
      isLoading={login.isLoading}
      onFieldChange={login.updateFormField}
      onSubmit={login.handleLoginSubmit}
      onForgotPassword={login.openForgotMode}
      onRent={login.goToRent}
    />
  )
}
